import moreEn from './en/en.json'
import moreAr from './ar/ar.json'
import moreEs from './es/es.json'
import moreDe from './de/de.json'
import moreIt from './it/it.json'
import moreFr from './fr/fr.json'
import morePt from './pt/pt.json'
import moreEl from './el/el.json'
import moreBn from './bn/bn.json'
import moreSr from './sr/sr.json'
import moreCs from './cs/cs.json'
import morePl from './pl/pl.json'
import moreHu from './hu/hu.json'
import moreSk from './sk/sk.json'
import moreRo from './ro/ro.json'
import moreBg from './bg/bg.json'
import moreMk from './mk/mk.json'
import moreSq from './sq/sq.json'

const MoreMessages = {
  en: { more: { ...moreEn } },
  ar: { more: { ...moreAr } },
  es: { more: { ...moreEs } },
  de: { more: { ...moreDe } },
  it: { more: { ...moreIt } },
  fr: { more: { ...moreFr } },
  pt: { more: { ...morePt } },
  el: { more: { ...moreEl } },
  bn: { more: { ...moreBn } },
  sr: { more: { ...moreSr } },
  cs: { more: { ...moreCs } },
  pl: { more: { ...morePl } },
  hu: { more: { ...moreHu } },
  sk: { more: { ...moreSk } },
  ro: { more: { ...moreRo } },
  bg: { more: { ...moreBg } },
  mk: { more: { ...moreMk } },
  sq: { more: { ...moreSq } },
}

export default MoreMessages
